import { SendHorizontal } from 'lucide-react';
import type { NavItem } from './types';

/**
 * Destino «Envíos en revisión» (§4.12), vista 12.
 *
 * It was hidden by D11 (§5 of the screen inventory) until `GET /api/dtes`
 * accepted the `envioStatus` filter. It is worth saying what was resolved and
 * what was NOT, because the difference is deliberate: **there is no
 * `GET /api/envios`**. The live envelope already travels embedded in the DTE's
 * detail, so a listing of envelopes of its own would be a second source of
 * truth over the same value, and two sources of truth disagree. The view is
 * built by filtering documents by their envelope's status, which is the same
 * question answered from the source that already exists (A-04 of the frontend roadmap).
 */
export const enviosNav: readonly NavItem[] = [
  {
    label: 'Envíos en revisión',
    to: '/envios',
    icon: SendHorizontal,
    group: 'operation',
    minimumPhase: 'in-certification',
  },
];
